export default __webpack_public_path__ + "static/economic_growth-437bdcc10ee6a281e35cfb9c5d720f0b.png";